module.exports = __webpack_public_path__ + "2c8d95975efa7c63ca5c06b6b0bcf41e.pdf";